
export const home = {
  'home.title': 'subvention360',

  // Narrative hook
  'home.hero.hook': 'Chaque année, €3 milliards de subventions restent inutilisés.',
  'home.hero.hookSub': 'Pas parce que les entreprises ne sont pas éligibles — mais parce que trouver la bonne aide est trop complexe.',

  // Hero section - Problem/Solution narrative
  'home.hero.title': 'Trouvez €10K-€500K en Subventions Françaises',
  'home.hero.titleHighlight': 'Sans Perdre 20 Heures en Recherche',
  'home.hero.mission': 'subvention360 existe pour réparer cela. Nous croyons que chaque entrepreneur, association et collectivité mérite un accès égal aux financements publics — en minutes, pas en mois.',
  'home.hero.description': '144 434 subventions centralisées • Matching IA validé (+231,8% de précision) • 5 minutes pour vos résultats',
  'home.hero.cta.primary': '🎯 Trouvez Vos Aides Maintenant',
  'home.hero.cta.noCard': 'Aucun paiement immédiat requis',
  'home.hero.cta.tryFree': 'Commencer Gratuitement',

  // Live metrics
  'home.metrics.title': '📊 En Direct',
  'home.metrics.subsidies': 'Subventions',
  'home.metrics.successRate': 'Taux de Succès',
  'home.metrics.funding': 'Obtenus par Nos Clients',
  'home.metrics.updated': 'Mis à jour quotidiennement',

  // Social proof section
  'home.socialProof.title': '💬 Ils Nous Font Confiance',
  'home.socialProof.quote1': 'subvention360 m\'a fait gagner 15 heures par semaine.',
  'home.socialProof.author1': 'Marie, Consultante',
  'home.socialProof.quote2': '€280K obtenus en 6 mois grâce à subvention360.',
  'home.socialProof.author2': 'Pierre, CEO Startup',
  'home.socialProof.quote3': 'Sans subvention360, on aurait raté l\'EIC Accelerator.',
  'home.socialProof.author3': 'Sophie, CTO',

  // Competitive advantage section
  'home.competitive.title': '🆚 Pourquoi subvention360 ?',
  'home.competitive.vsConsultants': 'vs Consultants',
  'home.competitive.vsConsultantsValue': '€9,99 au lieu de €5K-€15K',
  'home.competitive.vsAidesTerritoires': 'vs Aides-Territoires',
  'home.competitive.vsAidesTerritoiresValue': '144 434 aides (vs 7 000)',
  'home.competitive.vsManual': 'vs Recherche Manuelle',
  'home.competitive.vsManualValue': '5 min (vs 20 heures)',

  // Features section
  'home.features.noAccount.title': 'Sans Inscription',
  'home.features.noAccount.aiSearch': 'Décrivez votre projet et l\'IA trouve les subventions adaptées',
  'home.features.noAccount.explore': 'Explorez des milliers d\'aides avec des explications claires',
  'home.features.noAccount.discover': 'Trouvez des conseillers experts pour vous accompagner',
  'home.features.noAccount.freeTriesNote': 'Vous avez droit à 3 recherches gratuites',

  'home.features.withAccount.title': 'Avec Votre Compte (Particuliers & Professionnels)',
  'home.features.personal.title': 'Pour Vous',
  'home.features.personal.recommendations': 'Recommandations sur-mesure selon votre profil et vos projets',
  'home.features.personal.save': 'Sauvegardez vos subventions et suivez vos candidatures',
  'home.features.personal.alerts': 'Alertes automatiques pour les nouvelles opportunités',

  'home.features.professional.title': 'Pour Les Professionnels',
  'home.features.professional.platform': 'Créez votre propre plateforme pour vos clients',
  'home.features.professional.track': 'Suivez toutes les aides actuelles et passées de votre portefeuille',
  'home.features.professional.dashboard': 'Tableau de bord professionnel pour gérer les dossiers de subventions',
  'home.features.professional.history': 'Historique complet des financements obtenus par vos clients',

  'home.features.summary': 'Du financement startup aux aides territoriales, de l\'innovation au développement durable - tout y est, rendu simple par l\'IA.',

  // Trust indicators
  'home.trust.title': '🏆 Pourquoi Nous Faire Confiance ?',
  'home.trust.coverage': '144 434 subventions françaises centralisées',
  'home.trust.accuracy': '+231,8% de précision vs recherche manuelle (validé)',
  'home.trust.speed': 'Résultats en 5 minutes au lieu de 20 heures',
  'home.trust.success': '67% de taux de succès avec notre intelligence historique',

  // Final CTA
  'home.cta.title': 'Prêt à Débloquer Vos Financements ?',
  'home.cta.subtitle': 'Rejoignez les milliers d\'entrepreneurs qui ont déjà sécurisé €4,8M grâce à subvention360',
  'home.cta.button': 'Commencer Maintenant',
  'home.trust': 'Des milliers d\'entrepreneurs, associations et conseillers nous font déjà confiance.',

  // Privacy promise
  'home.privacy.title': '🔒 Vos Données Restent Privées',
  'home.privacy.promise': 'Nous ne revendons JAMAIS vos informations. Aucun appel commercial. Aucune sollicitation. Vos données servent uniquement à trouver VOS subventions.',
  'home.privacy.guarantee': '100% privé • Pas de spam • Pas d\'appels intempestifs',

  'home.loading': 'Chargement...',

  // Product details section
  'home.productDetails.title': 'Envie d\'en savoir plus sur notre solution ?',
  'home.productDetails.description': 'Découvrez en détail comment subvention360 peut transformer votre façon de gérer les subventions',
  'home.productDetails.button': 'En savoir plus sur notre produit',

  // Tagline (brand positioning)
  'home.tagline': 'L\'intelligence qui débloque vos financements',

  // B2B Landing Page (Consultant-focused)
  'home.b2b.header.pricing': 'Tarifs',
  'home.b2b.header.login': 'Se connecter',

  // B2B Hero Section
  'home.b2b.hero.title': 'Obtenez en quelques minutes les financements publics les plus adaptés à chacun de vos clients.',
  'home.b2b.hero.titleLine2': '',
  'home.b2b.hero.titleLine3': '',
  'home.b2b.hero.titleHighlight': '',
  'home.b2b.hero.description': 'Subvention360 identifie et personnalise tous les dispositifs: subventions, avances remboursables, prêts à taux préférentiels, garanties, CIR et allègements fiscaux. Un tableau de bord unique, une veille en temps réel et un Assistant IA dédié: l\'accompagnement complet pour chaque projet de financement.',
  'home.b2b.hero.tagline': 'Subvention360 identifie et personnalise tous les dispositifs: subventions, avances remboursables, prêts à taux préférentiels, garanties, CIR et allègements fiscaux. Un tableau de bord unique, une veille en temps réel et un Assistant IA dédié: l\'accompagnement complet pour chaque projet de financement.',
  'home.b2b.hero.tagline2': 'Pour les experts-comptables, cabinets de conseil et consultants spécialisés en financement public pour accompagner leurs clients.',
  'home.b2b.hero.coverageTypes': 'Tous les dispositifs : subventions, avances remboursables, prêts à taux préférentiels, garanties, exonérations.',
  'home.b2b.hero.coverageScope': 'Les aides publiques locales, régionales, nationales et européennes.',

  // B2B Stats (Updated December 2025)
  'home.b2b.stats.subsidies': '5,000+',
  'home.b2b.stats.subsidiesLabel': 'Aides référencées',
  'home.b2b.stats.targeted': '10 - 40 aides',
  'home.b2b.stats.targetedLabel': 'Ciblées par client',
  'home.b2b.stats.pricing': '€49/mois',
  'home.b2b.stats.pricingLabel': 'Dès 5 clients',

  // B2B CTAs
  'home.b2b.cta.start': 'Démarrer maintenant',
  'home.b2b.cta.viewPricing': 'Voir les tarifs',
  'home.b2b.cta.startNow': 'Commencer maintenant',

  // B2B Trust Badges
  'home.b2b.trust.confidential': 'Hébergement sécurisé',
  'home.b2b.trust.operational': 'Opérationnel en 2 minutes',
  'home.b2b.trust.support': 'Aucun partage avec des tiers',

  // B2B Pain Points Section
  'home.b2b.pain.title': 'La recherche de financements publics prend trop de temps',
  'home.b2b.pain.titleHighlight': 'et fait passer vos clients à côté d\'opportunités',
  'home.b2b.pain.solution': 'Avec Subvention360, transformez cette veille administrative en avantage concurrentiel.',
  'home.b2b.pain.issue1.title': 'Gagnez un temps précieux',
  'home.b2b.pain.issue1.description': 'Avant : 2-3 heures de recherche manuelle par client\nMaintenant : Quelques minutes pour identifier toutes les aides pertinentes et éligibles\n→ <strong>Économisez jusqu\'à 90% de votre temps</strong>',
  'home.b2b.pain.issue2.title': 'Ne manquez plus aucune opportunité',
  'home.b2b.pain.issue2.description': 'Avant : Risque élevé de passer à côté d\'aides parmi {count}+ dispositifs\nMaintenant : Exhaustivité sur les types de financements et nouveaux dispositifs\n→ <strong>Optimisez les aides obtenues pour vos clients</strong>',
  'home.b2b.pain.issue3.title': 'Valorisez votre expertise',
  'home.b2b.pain.issue3.description': 'Avant : Un travail de recherche pour les projets de clients et identifications des dispositifs\nMaintenant : Un Assistant IA spécialisé et personnalisé par client qui vous accompagne\n→ <strong>Transformez la recherche d\'aides en conseil à haute valeur ajoutée</strong>',

  // B2B Features Section
  'home.b2b.features.title': 'Détectez les opportunités que vos clients n\'imaginent même pas',
  'home.b2b.features.subtitle': '',

  'home.b2b.feature1.title': 'Base de données la plus complète du marché',
  'home.b2b.feature1.description': 'Plus de {count} aides françaises et européennes • Mise à jour hebdomadaire • Couverture exhaustive : Européenne, Nationale, Régionale, Locale • Fiches détaillées avec critères d\'éligibilité précis',

  'home.b2b.feature2.title': 'Matching intelligent et personnalisé',
  'home.b2b.feature2.description': 'Notre algorithme adapte les résultats à chaque profil client • Analyse en temps réel de tous les critères • Pondération automatique des aides les plus pertinentes • Recommandations stratégiques par ordre de priorité',

  'home.b2b.feature3.title': 'Informations sur les nouveaux dispositifs',
  'home.b2b.feature3.description': 'Soyez le premier à informer vos clients • Notification des nouveaux dispositifs dès leur publication • Informations sur les nouveaux dispositifs correspondants à votre portefeuille clients • Anticipation des calendriers de dépôt',

  'home.b2b.feature4.title': 'L\'IA qui travaille pour vous',
  'home.b2b.feature4.description': 'Notre IA analyse automatiquement les sites web et documents officiels pour extraire les informations clés • Critères d\'éligibilité, montants, délais identifiés sans effort • Vous vous concentrez sur le conseil, l\'IA fait le reste',

  'home.b2b.feature5.title': 'Gestion centralisée multi-clients',
  'home.b2b.feature5.description': 'Pilotez l\'ensemble de vos clients depuis un seul tableau de bord • Multi-Collaborateur • Import multi clients (excel - CSV) plateforme s\'adapte à votre fichier',

  'home.b2b.feature6.title': 'Transmission des informations à vos clients',
  'home.b2b.feature6.description': 'Génération de PDF personnalisés avec votre branding • Synthèse par catégorie de financements • Envoi multi-aides en un clic • Communiquez les opportunités pertinentes à chaque client',

  // B2B How It Works
  'home.b2b.howItWorks.title': 'Opérationnel en 2 minutes seulement',
  'home.b2b.howItWorks.subtitle': '',

  'home.b2b.howItWorks.step1.title': 'Inscription immédiate et sécurisée',
  'home.b2b.howItWorks.step1.description': 'Formulaire simplifié sans engagement • Configuration du paiement sécurisé par prélèvement SEPA ou carte bancaire • Accès immédiat à la plateforme',

  'home.b2b.howItWorks.step2.title': 'Création de votre portefeuille clients',
  'home.b2b.howItWorks.step2.description': 'Création manuelle en moins de 30 secondes par Client • Importez vos fichiers Excel/CSV • Données cryptées et sécurisées',

  'home.b2b.howItWorks.step3.title': 'Découvrez les opportunités',
  'home.b2b.howItWorks.step3.description': 'Identification automatique de toutes les aides éligibles • Analyse priorisée par pertinence et potentiel • Assistant IA spécialisé pour l\'étude de dossiers complexes ou projet Client • Partagez les informations à vos clients',

  'home.b2b.howItWorks.footer': 'Paiement 100% sécurisé • Facturation mensuelle simple • Sans engagement • Support dédié inclus • Données protégées RGPD',

  // B2B Security Section
  'home.b2b.security.badge': '100% Sécurisé et Confidentiel',
  'home.b2b.security.title': 'Vos données en toute sécurité, votre sérénité garantie',
  'home.b2b.security.subtitle': 'Notre infrastructure certifiée protège vos informations les plus sensibles',

  'home.b2b.security.feature1.title': 'Hébergement souverain sécurisé',
  'home.b2b.security.feature1.description': 'Hébergé sur infrastructure Supabase (certifiée SOC 2) • Serveurs dans l\'Union Européenne (Francfort) • Sauvegardes automatiques multiples',

  'home.b2b.security.feature2.title': 'Protection des données avancée',
  'home.b2b.security.feature2.description': 'Algorithmes AES-256 pour les données au repos • Protocoles TLS 1.2+ pour les transferts sécurisés • Authentification sécurisée par email et mot de passe',

  'home.b2b.security.feature3.title': 'Conformité réglementaire totale',
  'home.b2b.security.feature3.description': 'Conformité RGPD complète • Respect des directives CNIL • Traçabilité des accès et actions',

  'home.b2b.security.feature4.title': 'Confidentialité absolue',
  'home.b2b.security.feature4.description': 'Aucun partage de données avec des tiers • Pas de réutilisation de vos informations • Vos clients restent intégralement les vôtres',

  'home.b2b.security.support.title': 'Support français inclus',
  'home.b2b.security.support.subtitle': 'Une équipe dédiée à votre réussite',
  'home.b2b.security.support.item1': 'Support par email - Réponse sous 48h ouvrées',
  'home.b2b.security.support.item2': 'Centre d\'aide complet avec guides pas à pas',
  'home.b2b.security.support.item3': 'Formation personnalisée incluse à l\'onboarding',
  'home.b2b.security.support.item4': 'Documentation complète et mise à jour régulière',

  // B2B Final CTA
  'home.b2b.finalCta.title': 'subvention360 votre partenaire en financements publics',
  'home.b2b.finalCta.subtitle': 'Dédié aux :',
  'home.b2b.finalCta.description': 'Cabinets de Conseil\nCabinets d\'Expertise-Comptable et leurs départements conseil\nCabinets d\'Audit et de Commissariat aux Comptes\nConseillers Financiers et en investissement\nConsultants Indépendants spécialisés en financement',
  'home.b2b.finalCta.evolution': 'Une solution en évolution permanente, avec de nouveaux services dédiés développés continuellement.',
  'home.b2b.finalCta.benefitsTitle': 'Ce que vous gagnez dès aujourd\'hui :',
  'home.b2b.finalCta.benefit1': 'Gagnez 2-3 heures de recherche par client',
  'home.b2b.finalCta.benefit2': 'Accédez à {count}+ aides avec matching automatique',
  'home.b2b.finalCta.benefit3': 'Valorisez votre expertise,\ndes rapports PDF professionnels',
  'home.b2b.finalCta.benefit4': 'Bénéficiez d\'une solution évolutive adaptée à vos besoins métier',
  'home.b2b.finalCta.benefit5': 'Développez votre chiffre d\'affaires conseil',
  'home.b2b.finalCta.guaranteesTitle': 'Vos garanties Subvention360 :',
  'home.b2b.finalCta.guarantee1': 'Paiement 100% sécurisé par Stripe - Certification PCI DSS',
  'home.b2b.finalCta.guarantee2': 'Facturation mensuelle flexible adaptée à votre volume',
  'home.b2b.finalCta.guarantee3': 'Sans engagement - Annulation à tout moment en 1 clic',
  'home.b2b.finalCta.guarantee4': 'Support français par email - Réponse sous 48h ouvrées',
  'home.b2b.finalCta.guarantee5': 'Évolutions régulières - Nouveaux services en continu',
  'home.b2b.finalCta.closing': 'Rejoignez l\'écosystème des professionnels qui innovent dans l\'accompagnement financier',

  // SEO
  'home.seo.title': 'Plateforme de recherche de subventions pour professionnels',
  'home.seo.description': 'Plateforme B2B dédiée aux cabinets conseil et experts-comptables. 10 000+ aides et subventions françaises et européennes. Recherche par profil client, exports PDF, gestion multi-clients.',
  'home.seo.keywords': 'subventions cabinets conseil, plateforme subventions professionnels, experts-comptables aides, recherche subventions, financement public, aides entreprises, subventions européennes',

  // Navigation & UI elements
  'home.b2b.header.features': 'Fonctionnalités',
  'home.b2b.header.company': 'Entreprise',
  'home.b2b.header.dashboard': 'Tableau de bord',
  'home.b2b.cta.trial': 'Essai',
  'home.b2b.cta.trialFree': 'Essai gratuit',
  'home.b2b.cta.requestDemo': 'Demander une démo',
  'home.b2b.features.exploreAll': 'Explorer toutes les fonctionnalités',
  'home.b2b.howItWorks.badge': 'Notifications Temps Réel',
  'home.b2b.hero.videoFallback': 'Démonstration vidéo',

  // Feature modal UI
  'home.b2b.modal.keyPoints': 'Points clés',
  'home.b2b.modal.tryFree': 'Essayer gratuitement',
  'home.b2b.modal.screenshot': 'Capture d\'écran',

  // Feature CTAs
  'home.b2b.feature1.cta': 'Explorer la base',
  'home.b2b.feature2.cta': 'Découvrir le matching',
  'home.b2b.feature3.cta': 'Activer les alertes',
  'home.b2b.feature4.cta': 'Découvrir l\'IA',
  'home.b2b.feature5.cta': 'Gérer les clients',
  'home.b2b.feature6.cta': 'Voir les modèles',

  // Feature modal content
  'home.b2b.feature1.modalTitle': 'Base de données exhaustive',
  'home.b2b.feature1.modalDescription': 'Accédez à la plus grande base de données d\'aides et subventions en France, mise à jour quotidiennement par notre équipe et nos algorithmes.',
  'home.b2b.feature1.modalHighlight1': 'Plus de {count} dispositifs d\'aides référencés',
  'home.b2b.feature1.modalHighlight2': 'Couverture nationale et régionale complète',
  'home.b2b.feature1.modalHighlight3': 'Mise à jour quotidienne des informations',
  'home.b2b.feature1.modalHighlight4': 'Fiches détaillées avec critères d\'éligibilité',

  'home.b2b.feature2.modalTitle': 'Matching intelligent et personnalisé',
  'home.b2b.feature2.modalDescription': 'Notre algorithme de matching analyse le profil de chaque client pour identifier les aides les plus pertinentes parmi notre base de données de plus de {count} dispositifs.',
  'home.b2b.feature2.modalHighlight1': 'Analyse automatique du profil entreprise (secteur, taille, localisation)',
  'home.b2b.feature2.modalHighlight2': 'Score de compatibilité pour chaque aide identifiée',
  'home.b2b.feature2.modalHighlight3': 'Mise à jour en temps réel selon les évolutions du profil',
  'home.b2b.feature2.modalHighlight4': 'Filtrage intelligent pour éviter les faux positifs',

  'home.b2b.feature3.modalTitle': 'Alertes nouveaux dispositifs',
  'home.b2b.feature3.modalDescription': 'Ne manquez plus aucune opportunité grâce à notre système d\'alertes intelligent qui vous notifie dès qu\'une nouvelle aide correspond au profil de vos clients.',
  'home.b2b.feature3.modalHighlight1': 'Notifications en temps réel des nouvelles aides',
  'home.b2b.feature3.modalHighlight2': 'Alertes personnalisées par client ou par secteur',
  'home.b2b.feature3.modalHighlight3': 'Résumé hebdomadaire des opportunités',
  'home.b2b.feature3.modalHighlight4': 'Alertes sur les dates limites de dépôt',

  'home.b2b.feature4.modalTitle': 'L\'IA qui travaille pour vous',
  'home.b2b.feature4.modalDescription': 'Notre intelligence artificielle analyse automatiquement les sites web officiels et documents pour extraire les informations clés, vous faisant gagner un temps précieux.',
  'home.b2b.feature4.modalHighlight1': 'Extraction automatique des critères d\'éligibilité',
  'home.b2b.feature4.modalHighlight2': 'Identification des montants et taux de financement',
  'home.b2b.feature4.modalHighlight3': 'Détection des dates limites et conditions',
  'home.b2b.feature4.modalHighlight4': 'Enrichissement continu de la base de données',

  'home.b2b.feature5.modalTitle': 'Gestion centralisée multi-clients',
  'home.b2b.feature5.modalDescription': 'Gérez l\'ensemble de votre portefeuille clients depuis une interface unique et intuitive, avec un suivi personnalisé pour chacun.',
  'home.b2b.feature5.modalHighlight1': 'Tableau de bord unifié pour tous vos clients',
  'home.b2b.feature5.modalHighlight2': 'Profils entreprise complets et personnalisables',
  'home.b2b.feature5.modalHighlight3': 'Suivi des dossiers et des opportunités',
  'home.b2b.feature5.modalHighlight4': 'Gestion des droits d\'accès par collaborateur',

  'home.b2b.feature6.modalTitle': 'Transmission des informations à vos clients',
  'home.b2b.feature6.modalDescription': 'Communiquez efficacement avec vos clients grâce à nos outils de génération de documents personnalisés et d\'envoi d\'informations ciblées.',
  'home.b2b.feature6.modalHighlight1': 'Génération de PDF personnalisés avec votre branding',
  'home.b2b.feature6.modalHighlight2': 'Synthèse par catégorie de financements disponibles',
  'home.b2b.feature6.modalHighlight3': 'Envoi multi-aides en un clic par email',
  'home.b2b.feature6.modalHighlight4': 'Historique des communications pour chaque client',

  // Footer
  'home.b2b.footer.description': 'La plateforme intelligente pour gérer toutes les subventions et aides de vos clients en un seul endroit.',
  'home.b2b.footer.platform': 'Plateforme',
  'home.b2b.footer.legal': 'Légal',
  'home.b2b.footer.features': 'Fonctionnalités',
  'home.b2b.footer.pricing': 'Tarifs',
  'home.b2b.footer.blog': 'Blog',
  'home.b2b.footer.freeTrial': 'Essai gratuit',
  'home.b2b.footer.legalNotice': 'Mentions légales',
  'home.b2b.footer.privacy': 'Confidentialité',
  'home.b2b.footer.terms': 'CGU',
  'home.b2b.footer.copyright': '© 2025 Subvention360. Tous droits réservés.',
  'home.b2b.footer.hostedIn': 'Hébergé en France',

  // Contact
  'home.b2b.footer.contact': 'Nous contacter',
  'home.b2b.footer.contactIntro': 'Une question ? Notre équipe est à votre écoute pour vous accompagner dans votre projet.',

  // Blog Page
  'blog.pageTitle': 'Blog - Actualités Subventions',
  'blog.metaDescription': 'Découvrez les dernières actualités sur les subventions et aides publiques en France. Conseils, analyses et opportunités de financement.',
  'blog.title': 'Blog',
  'blog.subtitle': 'Retrouvez nos dernières publications sur les subventions et aides publiques en France',
  'blog.error': 'Erreur lors du chargement des articles',
  'blog.noPosts': 'Aucun article disponible pour le moment',
  'blog.viewOnLinkedIn': 'Voir sur LinkedIn',
  'blog.followCta': 'Suivez-nous sur LinkedIn pour ne rien manquer',
  'blog.followButton': 'Suivre Subvention360',
} as const;
